<template>
  <div class="bg-light">
    <!-- Header -->
    <!-- Main Content -->
    <main class="container my-4">
      <div class="row">
        <!-- Passenger Info Form -->
        <div class="col-lg-12 mb-4">
          <div class="position-relative m-4">
            <div class="progress" style="height: 3px;">
              <div class="progress-bar bg-zebra" role="progressbar" style="width: 50%;" aria-valuenow="50"
                aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="d-flex justify-content-between position-absolute w-100" style="top: -10px;">
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-zebra text-white d-flex align-items-center justify-content-center"
                  style="width: 25px; height: 25px;">
                  <i class="fas fa-plane-departure small"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Datos de viaje</small>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-zebra text-white d-flex align-items-center justify-content-center"
                  style="width: 25px; height: 25px;">
                  <i class="fas fa-calculator small"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Cotizar</small>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-zebra text-white d-flex align-items-center justify-content-center"
                  style="width: 25px; height: 25px;">
                  <i class="fas fa-shopping-cart small"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Comprar</small>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center">
                <div class="rounded-circle bg-light border d-flex align-items-center justify-content-center"
                  style="width: 25px; height: 25px;">
                  <i class="fas fa-check small text-muted"></i>
                </div>
                <div class="text-center mt-2">
                  <small class="d-block text-muted">Finalizar</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 mb-12">
          <div class="bg-white rounded-lg shadow-lg p-4">
            <div style="margin-bottom: 1rem">
              <DetalleCompra :cotizar="cotizar" page="datosCompra" v-on:pagar="pagar"></DetalleCompra>
            </div>

            <h3 class="font-weight-bold mb-4 text-zebra text-start"><strong> Información de Pasajeros </strong></h3>

            <form>
              <!-- Accordion -->
              <div class="accordion" id="accordionExample">
                <!-- INFORMACION PASAJEROS -->
                <div class="accordion-item" v-for="(pasajero, index) in order.beneficiaries" :key="index">
                  <h2 class="accordion-header" :id="'pasajero' + index">
                    <button
                      class="accordion-button collapsed bg-zebra-light"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#collapsePasajero' + index"
                      :aria-expanded="activeIndex === index ? 'true' : 'false'"
                      :aria-controls="'collapsePasajero' + index"
                      @click="setActiveIndex(index)"
                    >
                      Pasajero {{ index + 1 }}
                    </button>
                  </h2>
                      <div
                        :id="'collapsePasajero' + index"
                        class="accordion-collapse collapse"
                        :class="{ show: activeIndex === index }"
                        :aria-labelledby="'pasajero' + index"
                        data-bs-parent="#accordionExample"
                      >
                    <div class="accordion-body">
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="form-floating">
                            <input type="text" class="form-control"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.name }" placeholder="Nombre"
                              v-model="pasajero.name">
                            <label>Nombre</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.name">
                            {{ errors.beneficiaries[index].name }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-floating">
                            <input type="text" class="form-control"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.lastName }" placeholder="Apellido"
                              v-model="pasajero.lastName">
                            <label>Apellido</label>
                            <div class="error-message" v-if="errors.beneficiaries[index]?.lastName">
                              {{ errors.beneficiaries[index].lastName }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <div class="form-floating">
                            <input type="date" class="form-control"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.birthdate }" @change="validarFechaNacimiento(pasajero.birthdate, pasajero.edad, index)"
                              placeholder="Fecha de Nacimiento" v-model="pasajero.birthdate">
                            <label>Fecha de Nacimiento</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.birthdate">
                            {{ errors.beneficiaries[index].birthdate }}
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-floating">
                            <input type="text" class="form-control" placeholder="Edad" v-model="pasajero.ageSelect" disabled>
                            <label>Edad</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.age">
                            {{ errors.beneficiaries[index].age }}
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-floating">
                            <select class="form-select" v-model="pasajero.country"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.country }">
                              <option :value="i.isoCountry" v-for="i in contries" :key="i.isoCountry">{{ i.description
                                }} </option>
                            </select>
                            <label>País</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.country">
                            {{ errors.beneficiaries[index].country }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <div class="form-floating">
                            <select class="form-select" v-model="pasajero.typeDocument"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.typeDocument }">
                              <option v-for="doc in tipoDocumentos" :key="doc.value" :value="doc.value">{{ doc.text }}</option>
                            </select>
                            <label>Tipo de Documento</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.typeDocument">
                            {{ errors.beneficiaries[index].typeDocument }}
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-floating">
                            <input type="text" class="form-control" placeholder="Documento" v-model="pasajero.document"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.document }">
                            <label>Documento</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.document">
                            {{ errors.beneficiaries[index].document }}
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-floating">
                            <input type="email" class="form-control" placeholder="Correo" v-model="pasajero.email"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.email }">
                            <label>Correo</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.email">
                            {{ errors.beneficiaries[index].email }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-8">
                          <div class="form-floating">
                            <div class="input-group flex-nowrap">
                              <div class="input-group-prepend">
                                <multiselect v-model="pasajero.codePhone" :options="contries" :searchable="true"
                                  :close-on-select="true" :show-labels="false" placeholder="Seleccione un país"
                                  track-by="codePhone" label="description"
                                  class="full-width-multiselect" noResult="No se encontraron resultados."
                                  selectLabel="Seleccionar" deselectLabel="Eliminar" selectedLabel="Seleccionado">
                                </multiselect>
                              </div>
                              <input type="text" class="form-control" placeholder="Teléfono" aria-label="Teléfono" v-model="pasajero.phone" :class="{ 'is-invalid': errors.beneficiaries[index]?.codePhone }">

                            </div>
                            <div class="error-message" v-if="errors.beneficiaries[index]?.phone">
                              {{ errors.beneficiaries[index].phone }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-floating">
                            <select class="form-select" v-model="pasajero.sex"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.sex }">
                              <option v-for="i in sexList" :key="i.id" :value="i.id">{{ i.value }}</option>
                            </select>
                            <label>Sexo</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.sex">
                            {{ errors.beneficiaries[index].sex }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="form-floating">
                            <select class="form-select" v-model="pasajero.toggleMedicalConditions">
                              <option value="Si">Si</option>
                              <option value="No">No</option>
                            </select>
                            <label>Condiciones Médicas</label>
                          </div>
                        </div>
                      </div>

                      <div v-if="pasajero.toggleMedicalConditions === 'Si'" class="row mb-3">
                        <div class="col-md-12">
                          <div class="form-floating">
                            <textarea class="form-control" placeholder="Escriba las condiciones médicas"
                              v-model="pasajero.medicalDetails"
                              :class="{ 'is-invalid': errors.beneficiaries[index]?.medicalDetails }"></textarea>
                            <label>Detalle de Condiciones Médicas</label>
                          </div>
                          <div class="error-message" v-if="errors.beneficiaries[index]?.medicalDetails">
                            {{ errors.beneficiaries[index].medicalDetails }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Add emergency contact fields here -->
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                          class="accordion-button"
                          :class="{ collapsed: !isEmergenciaVisible }"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          :aria-expanded="isEmergenciaVisible.toString()"
                          aria-controls="collapseOne"
                          @click="toggleEmergencia"
                        >
                      Contacto de Emergencia
                    </button>
                  </h2>
                  <div
                      id="collapseOne"
                      class="accordion-collapse collapse"
                      :class="{ show: isEmergenciaVisible }"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                    <div class="accordion-body">
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="form-floating">
                            <input type="text" class="form-control" placeholder="Nombre" v-model="order.nameContact"
                              :class="{ 'is-invalid': errors.contact?.nameContact }">
                            <label>Nombre completo</label>
                          </div>
                          <div class="error-message" v-if="errors.contact?.nameContact">
                            {{ errors.contact.nameContact }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-floating">
                            <input type="text" class="form-control" placeholder="Nombre" v-model="order.emailContact"
                              :class="{ 'is-invalid': errors.contact?.emailContact }">
                            <label>Correo</label>
                            <div class="error-message" v-if="errors.contact?.emailContact">
                              {{ errors.contact.emailContact }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="input-group flex-nowrap">
                            <div class="input-group-prepend">
                              <div class="form-floating">
                                <!-- <select class="form-select" style="max-width: 110px;" v-model="order.codePhoneContact" :class="{ 'is-invalid': errors.contact?.codePhoneContact }">
                                    <option :value="i.codePhone" v-for="i in contries" :key="i.codePhone">+{{i.codePhone }} - {{ i.description }} </option>
                                  </select> -->
                                <multiselect v-model="order.codePhoneContact" :options="contries" :searchable="true"
                                  :close-on-select="true" :show-labels="false" placeholder="Seleccione un país"
                                  track-by="codePhone" label="description"
                                  class="full-width-multiselect" noResult="No se encontraron resultados."
                                  selectLabel="Seleccionar" deselectLabel="Eliminar" selectedLabel="Seleccionado" :reduce="country => country.codePhone">
                                </multiselect>
                                <div class="error-message" v-if="errors.contact?.codePhoneContact">
                                  {{ errors.contact.codePhoneContact }}
                                </div>
                              </div>
                            </div>
                            <div class="form-floating">
                              <input type="text" class="form-control" placeholder="Teléfono" aria-label="Teléfono"
                                v-model="order.phoneContact" :class="{ 'is-invalid': errors.contact?.phoneContact }">
                              <label for="floatingInput">Teléfono</label>
                              <div class="error-message" v-if="errors.contact?.phoneContact">
                                {{ errors.contact.phoneContact }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Add emergency contact fields here -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer bg-white text-center py-3" >
                <button class="btn btn-zebra btn-lg px-5" @click.prevent="pagar()">
                  Pagar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="paymentModalLabel">Información de Pago</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Tu formulario aquí -->
            <form @submit.prevent="processPayment">
              <!-- ... contenido del formulario ... -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <script src="https://checkout.wompi.co/widget.js"></script> -->

<script>
import DetalleCompra from '@/components/components/DetalleCompra';
import Multiselect from 'vue-multiselect'

export default {
  data() {
    return {
      errors: {
        beneficiaries: [],
        contact: {}
      },
      activeAccordion: null, 
      isEmergenciaVisible: false,
      urlBase: process.env.VUE_APP_API_URL_ZEBRA,
      submitStatus: null,
      erroresFormulario: [],
      cotizar: {},
      contries: [],
      tipoDocumentos: [],
      sexList: [
        { id: 'i', value: ' No especificar ' },
        { id: 'm', value: ' Masculino ' },
        { id: 'f', value: ' Femenino ' },
      ],
      order: {
        beneficiaries: [],
        nameContact: '',
        emailContact: '',
        phoneContact: '',
        codePhoneContact: ''
      },
    };
  },
  mounted() {
    this.cotizar = JSON.parse(localStorage.getItem('cotizar'));
    const c = this.cotizar;
    this.order = {
      idPlan: c.plan.id,
      origin: c.origen,
      destination: c.destino,
      startDate: this.formatDate(c.fecha[0]),
      endDate: this.formatDate(c.fecha[1]),
      nameContact: "",
      emailContact: "",
      codePhoneContact: "",
      phoneContact: "",
      reference: "",
      individualVoucher: false,
      comment: "",
      beneficiaries: [],
    }
    for (let i = 0; i < this.cotizar.pasajeros.length; i++) {
      this.order.beneficiaries.push({
        name: "",
        lastName: "",
        birthdate: "",
        ageSelect: "",
        age: "",
        country: "",
        typeDocument: "",
        document: "",
        email: "",
        codePhone: "",
        phone: "",
        sex: "",
        medicalConditions: "",
        toggleMedicalConditions: 'No',
        edad: this.cotizar.pasajeros[i].edad
      });
    }
    this.getContries();
    this.getTypeDocuments();
  },
  methods: {
    setActiveIndex(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    togglePasajero(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    isPasajeroVisible(index) {
      return this.activeIndex === index;
    },

    formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const iso = date.toISOString().slice(0, 10); // "YYYY-MM-DD"
    return iso.replace(/-/g, '/'); // "YYYY/MM/DD"
    },
    pagar() {
      // this.openPaymentWidget();
       // En lugar de abrir directamente el widget, mostrar el modal
      // this.showPaymentModal = true;
       // Agregar listeners para eventos del modal
      if (this.validateForm()) {
        // Formatear fechas de cumpleaños de los beneficiarios
        this.order.beneficiaries.forEach(beneficiary => {
          if (beneficiary.birthdate) {
            beneficiary.birthdate = this.formatDate(beneficiary.birthdate);
          }
          if(beneficiary.codePhone) {
            beneficiary.codePhone = beneficiary.codePhone.codePhone
          }
        });
        this.order.codePhoneContact = this.order.codePhoneContact?.codePhone
        localStorage.setItem("order", JSON.stringify(this.order));
        this.$router.push('/pago');
        /** this.$root.post(`wompi/transaction`, this.order).then(res => {
          if (res.status == "ERROR") {
            alert(res.error.message)
          } else {
            localStorage.setItem("order", JSON.stringify(this.order));
          }
        }); */
        // Lógica de pago existente
      } else {
        console.log('Formulario inválido');
        // Mostrar mensaje de error
      }
    },
    // ... existing code ...
    // Función para generar la firma
    // Función de utilidad para ver el hex de un string
    stringToHex(str) {
      return Array.from(str).map(c => c.charCodeAt(0).toString(16).padStart(2, '0')).join('');
    },

    // Frontend (Vue component)
    async getContries() {
      try {
        const contries = (await this.$root.get('generals/countries')).data;
        this.contries = contries;
      } catch (error) {
        this.contries = [];
      }
    },
    async getTypeDocuments() {
      try {
        const response = await this.$root.get('orders/type_documents');
        this.tipoDocumentos = response.data.map(doc => ({
          value: doc.documentType,
          text: doc.description
        }));
      } catch (error) {
        console.error('Error cargando tipos de documento', error);
        this.tipoDocumentos = [];
      }
    },
    continuar() {

    },

    calcularEdad(fechaNacimiento) {
      const hoy = new Date();
      const fechaNac = new Date(fechaNacimiento);
      let edad = hoy.getFullYear() - fechaNac.getFullYear();
      const mes = hoy.getMonth() - fechaNac.getMonth();
      if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
        edad--;
      }
      return edad;
    },

    validarFechaNacimiento(fechaNacimiento, edadEsperada, index = null) {
      const edad = this.calcularEdad(fechaNacimiento);
      if (index !== null) {
        this.order.beneficiaries[index].ageSelect = edad
      }
      return edad === parseInt(edadEsperada);
    },

    validateForm() {
      let isValid = true;
      this.errors = {
        beneficiaries: [],
        contact: {}
      };

      this.activeIndex = null; // Reinicia la visibilidad de los pasajeros
      this.isEmergenciaVisible = false; // Oculta contacto de emergencia por defecto

      const setFirstInvalidAccordion = (index) => {
        if (this.activeIndex === null) this.activeIndex = index;
      };


      // Validar beneficiarios
      this.order.beneficiaries.forEach((beneficiary, index) => {
        this.errors.beneficiaries[index] = {};

        // Validar nombre
        if (!beneficiary.name || beneficiary.name.length < 2) {
          this.errors.beneficiaries[index].name = 'El nombre es requerido y debe tener al menos 2 caracteres';
          setFirstInvalidAccordion(index);
          isValid = false;
        }

        // Validar apellido
        if (!beneficiary.lastName || beneficiary.lastName.length < 2) {
          this.errors.beneficiaries[index].lastName = 'El apellido es requerido y debe tener al menos 2 caracteres';
          setFirstInvalidAccordion(index);
          isValid = false;
        }
        if (!beneficiary.phone) {
          this.errors.beneficiaries[index].phone = 'El teléfono es obligatorio';
          setFirstInvalidAccordion(index);
          isValid = false;
        } else if (beneficiary.phone.length !== 7 && beneficiary.phone.length !== 10) {
          this.errors.beneficiaries[index].phone = 'El teléfono debe tener 7 o 10 caracteres';
          setFirstInvalidAccordion(index);
          isValid = false;
        }

        // Validar fecha de nacimiento
        if (!beneficiary.birthdate) {
          this.errors.beneficiaries[index].birthdate = 'La fecha de nacimiento es requerida';
          setFirstInvalidAccordion(index);
          isValid = false;
        } else if (!this.validarFechaNacimiento(beneficiary.birthdate, beneficiary.edad)) {
          this.errors.beneficiaries[index].birthdate = 'La edad no corresponde con la seleccionada inicialmente';
          setFirstInvalidAccordion(index);
          isValid = false;
        }

        // Validar email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!beneficiary.email || !emailRegex.test(beneficiary.email)) {
          this.errors.beneficiaries[index].email = 'Email inválido';
          setFirstInvalidAccordion(index);
          isValid = false;
        }

        // Validar documento
        if (!beneficiary.document || beneficiary.document.length < 3 || beneficiary.document.length > 20) {
          this.errors.beneficiaries[index].document = 'Documento inválido (debe tener entre 3 y 20 caracteres)';
          setFirstInvalidAccordion(index);
          isValid = false;
        }
      });

      // Validar contacto de emergencia
      if (!this.order.nameContact) {
        this.errors.contact.nameContact = 'El nombre del contacto es requerido';
        this.isEmergenciaVisible = true;
        isValid = false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.order.emailContact || !emailRegex.test(this.order.emailContact)) {
        this.errors.contact.emailContact = 'El Correo es requerido';
        this.isEmergenciaVisible = true;
        isValid = false;
      }

      // Validar teléfono de contacto
      if (!this.order.phoneContact) {
        this.errors.contact.phoneContact = 'Teléfono del contacto requerido';
        this.isEmergenciaVisible = true;
        isValid = false;
      } else if (this.order.phoneContact.length !== 7 && this.order.phoneContact.length !== 10) {
        this.errors.contact.phoneContact = 'El teléfono debe tener 7 o 10 caracteres';
        this.isEmergenciaVisible = true;
        isValid = false;
      }

      return isValid;
    },
    // Métodos adicionales aquí
  },
  components: {
    DetalleCompra,
    Multiselect
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.full-width-multiselect {
  width: 100%;
}

.full-width-multiselect .multiselect__tags {
  width: 100%;
}

.full-width-multiselect .multiselect__content-wrapper {
  width: 100%;
}

.full-width-multiselect .multiselect__input {
  width: 100%;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.is-invalid {
  border-color: #dc3545;
}

.bg-teal {
  background-color: #20c997;
}

.bg-teal.text-white {
  background-color: #17a2b8 !important;
}
</style>
